import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  Inject,
} from '@angular/core';
import { Location } from '@angular/common';
import { Router, ActivatedRoute, Route } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { IPartner } from 'src/app/core/interfaces/shared/IPartner.interface';
import { environment } from 'src/environments/environment';
import { Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import {
  MsalGuardConfiguration,
  MsalService,
  MSAL_GUARD_CONFIG,
} from '@azure/msal-angular';
import { RedirectRequest } from '@azure/msal-browser';
import { selectPartner } from 'src/app/state/user/user.selectors';
import { MsalAccountService } from 'src/app/core/services/msal-account/msal-account.service';

export interface HeaderConfiguration {
  layoutAlign: string;
  sections: Sections[];
}
export interface Sections {
  backButton?: BackButton;
  close?: BackButton;
  partner?: boolean;
  menu?: boolean;
}
export interface BackButton {
  content?: string;
  output?: boolean;
  styles?: Array<string>;
  route?: string;
  relativeRoute?: boolean;
  isDialog?: boolean;
}

@Component({
  selector: 'header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  @Input() configuration: HeaderConfiguration;
  @Input() disabledNotification = true;
  @Output() onClickButton = new EventEmitter<any>();

  logoReale: string = `/assets/icons/${environment.logo}`;
  partnerData$: Observable<IPartner>;

  isIframe = false;
  loginDisplay = false;
  private readonly _destroying$ = new Subject<void>();

  allowedRoutes: Route[];

  constructor(
    @Inject(MSAL_GUARD_CONFIG)
    private msalGuardConfig: MsalGuardConfiguration,
    private location: Location,
    private router: Router,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private store: Store,
    private _msalAccountService: MsalAccountService,
    private _msalService: MsalService
  ) {

    this.partnerData$ = this.store.select(selectPartner);
    const account = this._msalAccountService.getAccountInfo();
    this.allowedRoutes = this._msalAccountService.allowedUrlsByRoles(account?.idTokenClaims?.roles || []);
  }

  ngOnInit(): void {
    // this.broadcastService.inProgress$
    //   .pipe(
    //     filter(
    //       (status: InteractionStatus) => status === InteractionStatus.None
    //     ),
    //     takeUntil(this._destroying$)
    //   )
    //   .subscribe(() => {
    //     this.setLoginDisplay();
    //   });
  }

  goToPreviousPage(
    route: string,
    relativeRoute: boolean = true,
    isDialog: boolean = true,
    output: boolean
  ): void {
    if (output) {
      this.onClickButton.emit();
    } else {
      if (isDialog) this.dialog.closeAll();
      !!route
        ? relativeRoute
          ? this.router.navigate([route], { relativeTo: this.route })
          : this.router.navigate([route])
        : this.location.back();
    }
  }

  login() {
    if (this.msalGuardConfig.authRequest) {
      this._msalService.loginRedirect({
        ...this.msalGuardConfig.authRequest,
      } as RedirectRequest);
    } else {
      this._msalService.loginRedirect();
    }
  }

  logout() {
    // Add log out function here
    this._msalService.logoutRedirect({
      postLogoutRedirectUri: environment.baseUrlRedirect,
    });
  }

  // setLoginDisplay() {
  //   this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
  // }

  /**
   * Return boolean value to apply active-link class on calculator menu item when the url is the base url
   * @returns boolean
   */
  actualRoute(route: Route): boolean {
    return this.route.routeConfig === route;
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }
}
